// extracted by mini-css-extract-plugin
module.exports = {"Link":"Admin_Link__260Za","Text":"Admin_Text__3dB6w","breadcrumb":"Admin_breadcrumb__cwGB0"};